export default class SearchDeclaracionesModel {
    constructor(data = {}) {
        this.serie = parseInt(data.serie) || 0;
        this.tipo = data.tipo || [];
        this.seccional = parseInt(data.seccional) || 0;
        this.departamento = parseInt(data.departamento) || 0;
        this.titular = data.titular || '';
        this.viniedo = data.viniedo || '';
        this.fecha_Inicial = data.fecha_Inicial
            ? new Date(data.fecha_Inicial)
            : new Date('0001-01-01');
        this.fecha_Final = data.fecha_Final
            ? new Date(data.fecha_Final)
            : new Date('0001-01-01');
    }
}
